import {Injectable} from '@angular/core';
import {SignalRConnectionResolver} from './signal-r-connection.resolver';
import {Location} from '@angular/common';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {HubConnection} from '@microsoft/signalr';
import {MesHttpStatusHandlerService} from './mes-http-status-handler.service';

@Injectable({
  providedIn: 'root'
})
export class CacheManagementHubResolver extends SignalRConnectionResolver {
  constructor(location: Location, private mesHttpStatusHandlerService: MesHttpStatusHandlerService) {
    super(location, 'cache-management');
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<HubConnection> {
    const resolve = super.resolve(route, state);

    resolve.then(connection => {
      connection.on('Reset', (region, id, cacheKey, entities) => {
        const targetRegion = CacheManagementHubResolver.getTargetRegionName(region);
        console.log(`Expire cache: ${targetRegion}, id: ${id}  with key:`);
        console.table(JSON.parse(cacheKey ?? '{}'));
        if (targetRegion) {
          this.mesHttpStatusHandlerService.setAppCacheVersion(cacheKey);
          this.mesHttpStatusHandlerService.cacheExpire$.next({region: targetRegion, id: id, cacheKey: cacheKey, entities: entities});
        }
      });
      connection.on('Remove', (region, id, cacheKey) => {
        const targetRegion = CacheManagementHubResolver.getTargetRegionName(region);
        console.log(`Remove id: ${id} from ${targetRegion} cache with key:`);
        console.table(JSON.parse(cacheKey ?? '{}'));
        if (targetRegion) {
          this.mesHttpStatusHandlerService.setAppCacheVersion(cacheKey);
          this.mesHttpStatusHandlerService.cacheRemove$.next({region: targetRegion, id: id, cacheKey: cacheKey});
        }
      });
    });

    return resolve;
  }

  private static getTargetRegionName(region: string): 'item' | 'unit' | 'property' | 'itemGroup' | 'classificatorValue' | 'costPriceComponent' | 'classificator' | 'process' | 'resource' | 'unknown' {
    if (region === 'manufacturing-items' || region === 'items') {
      return 'item';
    } else if (region === 'units') {
      return 'unit';
    } else if (region === 'properties') {
      return 'property';
    } else if (region === 'item-group') {
      return  'itemGroup';
    } else if (region === 'classificator-value') {
      return 'classificatorValue';
    } else if (region === 'cost-price-component') {
      return 'costPriceComponent';
    } else if (region === 'classificator' || region === 'process' || region === 'resource') {
      return region;
    }
  }
}
